import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { AiActionsModalComponent } from "./AiActionsModalComponent";

export interface AiActionsModalProps {
  afterClose?: () => void | Promise<void>;
  source?: string;
}

const AiActionsModalContent = ({ afterClose, source }: AiActionsModalProps) => (
  <AiActionsModalComponent afterClose={afterClose} source={source} />
);

const AiActionsModal = ModalManager.create(AiActionsModalContent);

export const useAiActionsModal = () => useModal(AiActionsModal);
